/**
 * Path constants for the organizer ("creator") console route tree.
 *
 * Single source of truth for organizer paths — downstream tasks (T020
 * registration page, T022 billing page, and any component that links or
 * navigates within the console) import from here instead of hardcoding
 * path strings.
 *
 * `ORGANIZER_PATHS` doubles as the route-definition shape (react-router
 * path patterns, e.g. `/evento/:id`) and, for the static paths, the
 * `navigate()` target. The two paths that carry a param need a concrete
 * value at navigate-time, so use the matching helper below instead of the
 * raw pattern.
 */
export const ORGANIZER_PATHS = {
  DASHBOARD: '/',
  REGISTRATION: '/registrazione',
  EVENT_NEW: '/evento/nuovo',
  EVENT_EDIT: '/evento/:id',
  EVENT_SPONSOR: '/evento/:id/sponsor',
  BILLING: '/fatturazione',
} as const;

/** Builds the concrete `/evento/:id` path for `navigate()` / `<Link>`. */
export function buildOrganizerEventEditPath(id: string): string {
  return `/evento/${id}`;
}

/** Builds the concrete `/evento/:id/sponsor` path for `navigate()` / `<Link>`. */
export function buildOrganizerEventSponsorPath(id: string): string {
  return `/evento/${id}/sponsor`;
}
